import Vue from 'vue';
import Alert from './components/misc/Alert.vue';
//import SvgIcon from './components/misc/SvgIcon.vue';

Vue.component(Alert.name, Alert);
//Vue.component(SvgIcon.name, SvgIcon);